module.exports = {"CLOSE_PRINT_WINDOW":"SLUIT","PRINT_HEAD":"LEVERINGSDOCUMENT VOOR KLANT","DELIVERED_PRODUCTS_TITLE":"GELEVERDE PRODUCTEN VOOR KLANT","NO":"NUMMER","PRODUCT_NAME":"PRODUCTNUMMER","SKU":"SKU","QUANTITY":"HOEVEEL","PRICE":"PRODUCTPRIJS","TOTAL":"TOTAAL","INFO_MESSAGE":"","TOTAL_PRICE":"TOTAAL PRIJS","WEIGHT":"GEWICHY","CURRENCY":"€","WEIGHT_TYPE":"GR","UNIT_PRICE":"PRIJS PER EENHEID"}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/staticTextMaps/printableArea.json
// module id = 307
// module chunks = 1